export default {
	data() {
		return {
			rules: {
				required: value => !!value || "required",
			}
		};
	}
};
